const LOAD_DATA_SLIDER_PHOTO           = 'LOAD_DATA_SLIDER_PHOTO'
const LOAD_DATA_SLIDER_PHOTO_SUCCESS   = 'LOAD_DATA_SLIDER_PHOTO_SUCCESS'
const LOAD_DATA_SLIDER_PHOTO_FAILED    = 'LOAD_DATA_SLIDER_PHOTO_FAILED'
const UNMOUNT_DATA_SLIDER_PHOTO        = 'UNMOUNT_DATA_SLIDER_PHOTO'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const sliderPhotoReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_SLIDER_PHOTO:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_SLIDER_PHOTO_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_SLIDER_PHOTO_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_SLIDER_PHOTO:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default sliderPhotoReducer;